module.exports = __webpack_public_path__ + "img/juice.7859d9d3.jpg";